import Script from './Script1.png';
import Shoot from './Shoot.png';
import Download from './Download.png';
import Edit from './Edit.png';
export const howItWorksData = [
  {
    title: "Script",
    description: "Import or write your script in a bullet point fashion.",
    image: Script
  },
  {
    title: "Shoot",
    description: "Pair Viddy from your phone or computer with any camera and record your script one line at a time, redoing each take until you get it right.",
    image: Shoot
  },
  {
    title: "Download",
    description: "After recording, Viddy creates an Editmap download with precise timestamps showing where your good takes are within your raw footage.",
    image: Download
  },
  {
    title: "Edit Faster",
    description: "Sync the Editmap with your footage and Instantly see where to make cuts without re-watching the footage or searching for edits manually. Edit 30 minutes of footage in under 5 minutes.",
    image: Edit
  },
];